import httpLib from './http-library';

export const Search = {
  getAvailableActivityPermalinks: () => {
    const requestParams = {
      path: `/v1/landing-pages/activity_types?ffilter=permalink`,
      timeout: 5000
    };
    return new Promise((resolve, reject) => {
      try {
        httpLib.request(requestParams, function (response) {
          resolve(response);
        }, null);
      } catch (error) {
        reject(error);
      }
    });
  },

  getAvailableLocationPermalinks: () => {
    const requestParams = {
      path: `/v1/landing-pages/city_types?ffilter=permalink&no_follow=false`,
      timeout: 5000
    };
    return new Promise((resolve, reject) => {
      try {
        httpLib.request(requestParams, function (response) {
          resolve(response);
        }, null);
      }
      catch (error) {
        reject(error);
      }
    });
  },

  getAvailablePermalinks() {
    return new Promise((resolve, reject) => {
      Promise.all([
        this.getAvailableActivityPermalinks(),
        this.getAvailableLocationPermalinks()
      ]).then((response) => {
        resolve({
          activities: response[0],
          locations: response[1]
        })
      }).catch((error) => {
        reject(error)
      })
    });
  }
};
